var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"mt-5",attrs:{"cols":"12","xs":"12","lg":"8"}},[_c('div',{attrs:{"width":"500"},domProps:{"innerHTML":_vm._s(_vm.markdown)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }